function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import cx from "classnames";
import { InputRut, InputPhone } from "../../../helperComponents/";
import defaultClient from "../defaultClient";
import ClientEmails from "./ClientEmails";
import AddressForm from "./AddressForm/AddressForm";
import ClientTabs from "./ClientTabs";
export var ColorHeader;

(function (ColorHeader) {
  ColorHeader[ColorHeader["Blue"] = 0] = "Blue";
  ColorHeader[ColorHeader["Gray"] = 1] = "Gray";
})(ColorHeader || (ColorHeader = {}));

var ClientDetail = function ClientDetail(props) {
  var title = props.title,
      _props$colorHeader = props.colorHeader,
      colorHeader = _props$colorHeader === void 0 ? ColorHeader.Blue : _props$colorHeader,
      _props$useCopyMode = props.useCopyMode,
      useCopyMode = _props$useCopyMode === void 0 ? false : _props$useCopyMode,
      _props$hasCopyFromOth = props.hasCopyFromOtherClient,
      hasCopyFromOtherClient = _props$hasCopyFromOth === void 0 ? false : _props$hasCopyFromOth,
      onChangeCheckCopy = props.onChangeCheckCopy,
      user = props.user,
      _onChange = props.onChange,
      _props$listComunas = props.listComunas,
      listComunas = _props$listComunas === void 0 ? [] : _props$listComunas,
      _props$listRegions = props.listRegions,
      listRegions = _props$listRegions === void 0 ? [] : _props$listRegions,
      token = props.token,
      _props$currentType = props.currentType,
      currentType = _props$currentType === void 0 ? "contratante" : _props$currentType,
      onChangeCurrentType = props.onChangeCurrentType,
      _props$onlyOneEmail = props.onlyOneEmail,
      onlyOneEmail = _props$onlyOneEmail === void 0 ? false : _props$onlyOneEmail,
      _props$showHeader = props.showHeader,
      showHeader = _props$showHeader === void 0 ? true : _props$showHeader;

  var onInputRutChange = function onInputRutChange(inputValue) {
    if (user.id) return _onChange(_objectSpread(_objectSpread({}, defaultClient), {}, {
      rut: inputValue
    }));
    return _onChange(_objectSpread(_objectSpread({}, user), {}, {
      rut: inputValue
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, showHeader && /*#__PURE__*/React.createElement("div", {
    className: cx(colorHeader === ColorHeader.Blue && "card-header cardHeader", colorHeader === ColorHeader.Gray && "card-footer")
  }, /*#__PURE__*/React.createElement(ClientTabs, {
    currentType: currentType,
    onChangeCurrentType: onChangeCurrentType
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody",
    style: {
      zIndex: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid row"
  }, useCopyMode && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: hasCopyFromOtherClient,
    onChange: onChangeCheckCopy
  }), "Copiar datos del contratante"))), !hasCopyFromOtherClient && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "h4 d-block mb-4 pb-3 border-bottom fw-bold"
  }, "Datos Personales:")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement(InputRut, {
    selectedUserId: user.id,
    onUserIsExist: function onUserIsExist(newUser) {
      _onChange(_objectSpread(_objectSpread({}, user), newUser));
    },
    value: user.rut,
    onInputChange: onInputRutChange,
    token: token
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tipo de persona ", /*#__PURE__*/React.createElement("span", {
    className: "text-danger"
  }, "*")), /*#__PURE__*/React.createElement("select", {
    className: "form-control",
    value: user.type,
    onChange: function onChange(event) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        type: event.target.value
      }));
    },
    required: true,
    disabled: hasCopyFromOtherClient || !user.rut
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Sin tipo seleccionado"), /*#__PURE__*/React.createElement("option", {
    value: "Users::NaturalPerson"
  }, "Persona Natural"), /*#__PURE__*/React.createElement("option", {
    value: "Users::LegalPerson"
  }, "Persona Jur\xEDdica"))), user.type === "Users::LegalPerson" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nombre ", /*#__PURE__*/React.createElement("span", {
    className: "text-danger"
  }, "*")), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.name,
    onChange: function onChange(event) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        name: event.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut
  }))), user.type === "Users::NaturalPerson" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Primer nombre ", /*#__PURE__*/React.createElement("span", {
    className: "text-danger"
  }, "*")), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.name,
    onChange: function onChange(event) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        name: event.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Segundo nombre"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.middle_name,
    onChange: function onChange(event) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        middle_name: event.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Primer apellido"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.first_surname,
    onChange: function onChange(event) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        first_surname: event.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Segundo apellido"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.second_surname,
    onChange: function onChange(event) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        second_surname: event.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement(InputPhone, {
    classNameInput: "form-control",
    value: user.phone,
    codeNumber: user.phone_code_number,
    disabled: hasCopyFromOtherClient || !user.rut,
    onChange: function onChange(phone, phone_code_number) {
      _onChange(_objectSpread(_objectSpread({}, user), {}, {
        phone: phone,
        phone_code_number: phone_code_number
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement(ClientEmails, {
    onlyOneEmail: onlyOneEmail,
    user: user,
    disabled: hasCopyFromOtherClient || !user.rut,
    onChange: function onChange(emails) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        emails: _toConsumableArray(emails)
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "h4 d-block mb-4 pb-3 border-bottom fw-bold"
  }, "Datos bancarios")), /*#__PURE__*/React.createElement("div", {
    className: "row g-3",
    style: {
      marginLeft: "0.5rem",
      marginRight: "0.5rem"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nombre titular"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.bank_account_holder_name || "",
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        bank_account_holder_name: e.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut,
    placeholder: "Nombre del titular de la cuenta"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "RUT titular"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.bank_account_holder_rut || "",
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        bank_account_holder_rut: e.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut,
    placeholder: "RUT del titular"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tipo de cuenta"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.bank_account_type || "",
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        bank_account_type: e.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut,
    placeholder: "Ej: Cuenta Corriente, Cuenta Vista"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N\xFAmero de cuenta"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.bank_account_number || "",
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        bank_account_number: e.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut,
    placeholder: "N\xFAmero de cuenta bancaria"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Banco"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.bank_name || "",
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        bank_name: e.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut,
    placeholder: "Nombre del banco"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Email bancario"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: user.bank_email || "",
    onChange: function onChange(e) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        bank_email: e.target.value
      }));
    },
    disabled: hasCopyFromOtherClient || !user.rut,
    placeholder: "Email para notificaciones bancarias"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "h4 d-block mb-4 pb-3 border-bottom fw-bold"
  }, "Datos de ubicaci\xF3n:")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(AddressForm, {
    user: user,
    listRegions: listRegions,
    listComunas: listComunas,
    onlyOneEmail: onlyOneEmail,
    disabled: hasCopyFromOtherClient || !user.rut,
    onChange: function onChange(addresses) {
      return _onChange(_objectSpread(_objectSpread({}, user), {}, {
        addresses: _toConsumableArray(addresses)
      }));
    }
  })))))));
};

export default ClientDetail;